import React, { useState, useEffect, useRef, useMemo } from 'react';
import {CreateLeadFooter, StyledGridContainer } from '../../Components/Styled/index';
import { Box, Button, Stack, Typography } from '@mui/material';
import history from '../../Utility/history';
import { privateRoutesPath } from '../../Routes';
import { useSnackbar } from 'notistack';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import { useSelector, useDispatch } from 'react-redux';
import { requestShowLoader, requestHideLoader } from '../../Store/Global/action';
import BiztantuLoader from '../../Components/Loader';
import DocumentManagement from '../../Components/DocumentManagement';
import { ACTIVE_STATUS, ADDITIONAL_ATTRIBUTE_FIELDS, handleValidateCodevalue, phoneCountryCodes, STATIC_ENTITY_CONFIG, VENDOR_DOC_TYPE, VENDOR_STATUS } from '../../Utility/constant';
import WhoColumnTextfieds from '../../Components/WhoColumnTextfieds';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import AddressFields from '../../Components/AddressFields';
import CommonComm from '../../Components/CommonComm';
import CommonPoc from '../../Components/CommonPoc';
import { getEntityColumns, getRequestData, updateRequestData, validateFields } from '../../Utility/apiHelper';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import LeadAccordion from '../../Components/LeadAccordion';
import AuditLogs from '../Configuration/Audit';

import { EntityNote } from '../../Components/EntityNote';
import NavigationBackButton from '../../Components/NavigationBackButton';
import { formatAdditionalAttributesForPayload } from '../../Utility/payloadFormatter';
import CustomizableFields from '../../Components/CustomizableFields';

const EditVendor = (props) => {
        const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);

    const location = useLocation();
    const canEdit = !!specificRolePermission?.isVendorManage;
    const [isEntityLocked, setIsEntityLocked] = useState(false);
    const isViewMode = !canEdit || isEntityLocked;
    // Audit Logs accordion — controlled so we can collapse it after actions; fetches lazily on expand
    const [isAuditAccordionExpanded, setIsAuditAccordionExpanded] = useState(false);
    const [isRequired, setRequiredValue] = useState(false);
    const [isIndia, setIsIndia] = useState(false);
    const inputRef = useRef(null);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [vendorDetail, setVendorDetail] = useState({
        ...phoneCountryCodes,
        state : "Other"
    })
    const [initialvendorDetails , setInitialvendorDetails] = useState()
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const merchantId = props.match.params.id;
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const vendorStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == VENDOR_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const docType = useSelector(state=> state?.lookup?.lookupData)?.find((item) => item?.name == VENDOR_DOC_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);                  
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);
    const vendorTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "VENDOR");
            return Object.keys(data).length > 0 ?  data : STATIC_ENTITY_CONFIG?.VENDOR;

    }, [allEntityData]);
          
    useEffect(() => {
    getvendorDetails(merchantId);
    }, [])

    const isloadingprogress = useSelector(state => state.global.isLoading);

    const getvendorDetails = async (merchantId) => {
        dispatch(requestShowLoader())
        
        try {
        const response = await getRequestData(`vendors/${merchantId}`);

        const vendorData = response?.data;

        setVendorDetail({
            ...vendorData,
            address: vendorData?.registeredAddress,
        });

        setInitialvendorDetails({
            ...vendorData,
            address: vendorData?.registeredAddress,
        });
    } catch (error) {
        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                error?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
            ),
            { variant: "error" }
        );
    } finally {
        dispatch(requestHideLoader());
    }
    }

    const handleChangeVendorData = (event) => {
        setVendorDetail({
            ...vendorDetail,
            [event.target.name]: event.target.value
        })
    }

    const handleUpdateMerchant = async (value = false) => {

        const {errors,hasError} = validateFields(vendorTextfieldsData, vendorDetail);
            if (hasError) {
                setRequiredValue(errors);
                    enqueueSnackbar(
                        handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"),
                    { variant: "error" }
                );
            return;
        } else {
        dispatch(requestShowLoader())
        if(JSON.stringify(initialvendorDetails) == JSON.stringify(vendorDetail)) {
            if (value == true) {
                history.push({
                    pathname: privateRoutesPath.PRODUCT,
                    state: {
                        goToMenu: 'VENDOR_SIDEBAR_MENU'
                    }
                });
            } else {
                enqueueSnackbar(`No data changed.`, {variant: 'info'});
            }
            dispatch(requestHideLoader());
            return;
        }
        const { created, id, updated, ...UpdatedmerchantData } = vendorDetail;
        const payload = formatAdditionalAttributesForPayload(
            {
            ...UpdatedmerchantData,
            registeredAddress : vendorDetail?.address                        },
            ADDITIONAL_ATTRIBUTE_FIELDS
        );
        try {
        const response = await updateRequestData(
            payload,
            `vendors/${merchantId}`
        );

        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                "COMMON_UPDATED_SUCCESSFULLY"
            ),
            { variant: "success" }
        );

        const vendorData = response?.data;

        setVendorDetail({
            ...vendorData,
            address: vendorData?.registeredAddress,
        });

        setInitialvendorDetails({
            ...vendorData,
            address: vendorData?.registeredAddress,
        });

        setIsAuditAccordionExpanded(false);

        if (value === true) {
            history.push({
                pathname: privateRoutesPath.PRODUCT,
                state: {
                    goToMenu: "VENDOR_SIDEBAR_MENU",
                },
            });
        }
    } catch (error) {
        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                error?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
            ),
            { variant: "error" }
        );
    } finally {
        dispatch(requestHideLoader());
    }
    }
    }

    const handleChangeDocument = (event) => {

        const file = event.target.files[0];

        if(file) {
            setSelectedDocumentType({
                ...selectedDocumentType,
                [event.target.name]: file
            })

        } else {
            setSelectedDocumentType({
                ...selectedDocumentType,
                [event.target.name]: event.target.value
            })
        }
       
    }

    const handleUploadDocument = () => {

    }

    const handleAuditAccordionChange = (_, isExpanded) => {
        setIsAuditAccordionExpanded(isExpanded);
    };

    return (
        <BiztantuLoader open={isloadingprogress} isChildren={true}>
             <Box className='globalBox'>
           
            {/* </StyledLeadContainer> */}
            {/* </StyledLeadContainer> */}
                {/* <StyledSubHeader>
                                 {handleValidateCodevalue(internationalise,'VEND_EDIT_VENDOR_DETAILS')}
                </StyledSubHeader> */}
                <LeadAccordion
                    label={`${handleValidateCodevalue(internationalise,'VEND_EDIT_VENDOR_DETAILS')} - ${merchantId}`}
                    defaultOpen={true}
                >
                {!isViewMode &&
                <Box className = "mt-15 mb-10">
                    <Button className='edit-primary' variant="outlined" onClick={handleUpdateMerchant}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}</Button>
                    <Button className='edit-primary btn-space' variant="outlined" onClick={()=>handleUpdateMerchant(true)}>{handleValidateCodevalue(internationalise,'COMMON_SAVE_AND_EXIT')}</Button>
                </Box>}
               <StyledGridContainer
                >
                 <TextFiledWithLabel
                        name="id"
                        disabled="true"
                        label={handleValidateCodevalue(internationalise,'VEND_EDIT_VEND_ID')}
                        value={vendorDetail?.id}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextFiledWithLabel
                        name="name"
                        inputRef={inputRef}
                        error = {vendorDetail?.name? false : isRequired?.name}
                        required= "true"
                        disabled={isViewMode}
                        label={handleValidateCodevalue(internationalise,'VEND_EDIT_NAME')}
                        handleOnChange={handleChangeVendorData}
                        value={vendorDetail?.name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        disabled = {isViewMode}
                        required
                        error = {vendorDetail?.status? false : isRequired?.status}
                        name= "status"
                        value= {vendorDetail?.status || ""}
                        isStatic={false}
                        optionMenuItem={vendorStatusData}
                        label={handleValidateCodevalue(internationalise,'VEND_EDIT_STATUS')}
                        handleOnChange={handleChangeVendorData}
                    />
                </StyledGridContainer>
                
            <CustomizableFields
                CUSTOMIZABLE_FIELDS={ADDITIONAL_ATTRIBUTE_FIELDS}
                entity = "VENDOR"
                config={vendorTextfieldsData}
                values={vendorDetail}
                isViewMode = {isViewMode}
                setValues={setVendorDetail}
                handleOnChange={handleChangeVendorData}
                errors={isRequired}
                />
                    <WhoColumnTextfieds
                    entityDetails={vendorDetail}
                    />
              
               <CommonComm
                isViewMode={isViewMode}
                required={true}
                requiredValue = {isRequired}
                isDetailPage = {true}
                handleOnChange={handleChangeVendorData}
                state = {vendorDetail}
               />
                    <AddressFields
                    setEntityDetails={setVendorDetail}
                    disabled = {isViewMode}
                    onChange={handleChangeVendorData}
                    entityDetails={vendorDetail}
                    />
               
                <CommonPoc
                isDetailPage={true}
                requiredValue={false}
                handleOnChange={handleChangeVendorData}
                state={vendorDetail}
                isViewMode={isViewMode}
                />

                    <EntityNote
                    entityDetails = {vendorDetail} 
                    onChange = {handleChangeVendorData}
                    headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
                  />

                    </LeadAccordion>
                <DocumentManagement
                entityType='vendorId'
                url = {`${process.env.REACT_APP_BASE_URL}vendor/documents`}
                docType={docType}
                isViewMode={isViewMode}
                clientId = {merchantId}
                onSuccess={() => setIsAuditAccordionExpanded(false)}
                />

                {specificRolePermission?.isAuditView  && <div>
                    <LeadAccordion
                        label={handleValidateCodevalue(internationalise,'COMMON_AUDIT_LOGS')}
                        expanded={isAuditAccordionExpanded}
                        onChange={handleAuditAccordionChange}
                        TransitionProps={{ unmountOnExit: true }}
                    >
                        <AuditLogs
                            label = ""
                            isSearchRequired = {false}
                            entityDetails = {{
                                entityId: merchantId,
                                entity: "VENDOR_SIDEBAR_MENU"
                            }}
                            module="vendor"
                        />
                    </LeadAccordion>
                    
                </div>}
            </Box>
            <CreateLeadFooter>
            <Stack alignItems="center" display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
               
                <Typography variant='h6' >
                        {`${handleValidateCodevalue(internationalise, 'VEND_EDIT_TITLE_EDIT')} - ${merchantId}`}
                </Typography>
               
            <NavigationBackButton 
                targetTab="VENDOR_SIDEBAR_MENU"
                additionalState={{ preserveSearch: true }} 
            />
            {/* {
           (specificRolePermission?.isVendorManage && isViewMode) && <Button  className='edit-primary' variant="outlined" onClick={() => setIsViewMode(!isViewMode)}>{handleValidateCodevalue(internationalise,'COMMON_EDIT')}</Button>
            } */}
            </Stack>
            </CreateLeadFooter>
        </BiztantuLoader>
    )
}



export default EditVendor;
